Confirm = require 'views/lib/confirm'
Dates = require 'lib/dates'
Util = require 'lib/util'
Promise = require 'bluebird'
t = require('views/internal/teacup-with-helpers')('board_clean_up')
track = require 'debug/track'
View = require 'view'
_ = require 'underscore'

template = t.renderable ({ ageCategories, lists }) ->
  canCleanLists = !_.isEmpty(lists)
  canCleanOldCards = !_.isEmpty(ageCategories)

  cardsSummary = (cards, canSelect) ->
    if canSelect
      t.div '.board-clean-up-cards-options', ->
        t.span '.board-clean-up-cards-option.js-select-all', ->
          t.format 'select-all'
        t.span '.board-clean-up-cards-option.js-select-none', ->
          t.format 'select-none'

    t.div '.board-clean-up-cards', ->
      for card in cards
        t.div '.board-clean-up-card', ->
          if canSelect
            t.div ->
              t.span '.board-clean-up-checkbox.js-toggle-checkbox', {
                'data-checked': 'checked',
                'data-card': card.id
              }, ->
                t.icon 'check', { class: 'board-clean-up-checkbox-check' }
          t.a '.list-card', { href: card.get('url') }, ->
            t.span '.board-clean-up-card-name', ->
              t.text card.get('name')

  t.div '.window-header.u-clearfix', ->

    t.span '.window-header-icon.icon-lg.icon-board'

    t.div '.window-title', ->
      t.h2 '.window-title-text', ->
        t.format 'board-clean-up'

  t.div '.window-main-col.window-main-col-full', ->
    if canCleanLists
      t.p '.board-clean-up-explanation', ->
        t.format 'it-looks-like-you-have-some-lists-that-havent-been-updated-recently'

      t.table '.board-clean-up-table', ->
        t.tbody ->
          t.tr ->
            t.th ->
              t.format 'list'
            t.th ->
              t.format 'cards'
            t.th ->
              t.format 'last-updated'
            t.th ->

          for { id, listName, cards, cardCount, lastModified } in lists
            t.tr '.board-clean-up-top', ->
              t.td ->
                t.text listName
              t.td ->
                t.text cardCount
              t.td ->
                t.text Dates.toDateString(lastModified)
              t.td '.board-clean-up-button-cell', ->
                t.button '.board-clean-up-button.js-archive-list', { 'data-list': id }, ->
                  t.format 'archive-list'
            t.tr '.board-clean-up-bottom', ->
              t.td { colspan: 4 }, ->
                cardsSummary(cards, false)

    if canCleanLists && canCleanOldCards
      t.hr()

    if canCleanOldCards
      t.p '.board-clean-up-explanation', ->
        if canCleanLists
          t.format 'you-can-also-clean-things-up-by-archiving-cards-that-havent-been-updated-in-a-while'
        else
          t.format 'you-can-clean-things-up-by-archiving-cards-that-havent-been-updated-in-a-while'

      t.table '.board-clean-up-table', ->
        t.tbody ->
          t.tr ->
            t.th ->
              t.format 'cards-updated'
            t.th ->
              t.format 'cards'
            t.th ->

          for key, cards of ageCategories
            t.tr '.board-clean-up-top.js-category-heading', { 'data-category': key }, ->
              t.td ->
                t.format ['more-than', key]
              t.td '.js-card-count', ->
                t.text cards.length
              t.td '.board-clean-up-button-cell', ->
                t.button '.board-clean-up-button.js-archive-category', { 'data-category': key }, ->
                  t.format 'archive-selected-cards'
            t.tr '.board-clean-up-bottom.js-category-cards', { 'data-category': key }, ->
              t.td { colspan: 3 }, ->
                cardsSummary(cards, true)

    if !(canCleanLists || canCleanOldCards)
      t.p '.board-clean-up-explanation', ->
        t.format 'it-doesnt-look-like-there-are-any-old-cards-to-clean-up'

progressTemplate = t.renderable ({ count, total }) ->
  t.div '.window-header.u-clearfix', ->

    t.span '.window-header-icon.icon-lg.icon-board'

    t.div '.window-title', ->
      t.h2 '.window-title-text', ->
        t.format 'board-clean-up'

  t.div '.window-main-col.window-main-col-full', ->
    t.div '.board-clean-up-progress', ->
      t.format "archiving", { count, total }

CATEGORIES =
  threeMonths:
    age: Util.getMs(days: 90)
  month:
    age: Util.getMs(days: 30)
  week:
    age: Util.getMs(days: 7)

# Minimum amount of time to spend per close, to keep from
# hitting rate limits
# With these settings we'd close 300 cards per minute
MINIMUM_TIME = 1000
CONCURRENCY = 5

filterByAttr = (attr, value) ->
  (index, el) => el.getAttribute(attr) == value

module.exports = class BoardCleanUpView extends View

  initialize: ->
    @progress = null
    @aborted = false

    @makeDebouncedMethods 'render'

    @listenTo @model.listList, 'add remove reset change:closed change:idBoard', @renderDebounced
    @listenForCards()
    return

  events:
    'click .js-archive-category': 'archiveCategory'
    'click .js-archive-list': 'archiveList'
    'click .js-toggle-checkbox': (e) ->
      $checkbox = @$(e.currentTarget)
      if $checkbox.is('[data-checked]')
        $checkbox.removeAttr('data-checked')
      else
        $checkbox.attr('data-checked', 'checked')

      @_updateCategory($checkbox.closest('.js-category-cards').attr('data-category'))

    'click .js-select-all': (e) ->
      $container = @$(e.currentTarget).closest('.js-category-cards')
      $container.find('.js-toggle-checkbox').attr('data-checked', 'checked')
      @_updateCategory($container.attr('data-category'))

    'click .js-select-none': (e) ->
      $container = @$(e.currentTarget).closest('.js-category-cards')
      $container.find('.js-toggle-checkbox').removeAttr('data-checked')
      @_updateCategory($container.attr('data-category'))

  _updateCategory: (category) ->
    matchesCategory = filterByAttr('data-category', category)
    $heading = @$('.js-category-heading').filter(matchesCategory)
    $cards = @$('.js-category-cards').filter(matchesCategory)

    uncheckedCards = $cards.find('.js-toggle-checkbox:not([data-checked])')
    checkedCards = $cards.find('.js-toggle-checkbox[data-checked]')

    $cards.find('.js-select-all').toggleClass('hide', !uncheckedCards.length)
    $cards.find('.js-select-none').toggleClass('hide', !checkedCards.length)

    $heading.find('.js-card-count').text(checkedCards.length)
    $heading.find('.js-archive-category').toggleClass('hide', !checkedCards.length)

  listenForCards: ->
    @listenTo @modelCache, 'add:Card remove:Card change:Card:closed change:Card:idList', @renderDebounced

  stopListeningForCards: ->
    @stopListening @modelCache

  _ageCategories: ->
    visibleCards = @modelCache.find 'Card', (card) =>
      card.get('idBoard') == @model.id &&
      card.isVisible()

    _.chain(CATEGORIES)
      .pairs()
      .map ([key, { age }]) ->
        cards = visibleCards.filter (card) ->
          Date.now() - Dates.parse(card.get('dateLastActivity')) > age

        [
          key,
          cards
        ]
      .filter ([key, cards]) -> cards.length > 0
      .object()
      .value()


  render: ->
    if @progress?
      @$el.html(progressTemplate(@progress))
      return @

    lists = @model.listList.chain()
      .filter (list) -> list.isOpen()
      .map (list) ->
        openCards = list.openCards().models

        newestCard = _.chain(openCards)
        .sortBy (card) ->
          card.get('dateLastActivity')
        .reverse()
        .first()
        .value()

        return {
          id: list.id
          listName: list.get('name')
          cardCount: openCards.length
          cards: openCards
          lastModified: newestCard?.get('dateLastActivity')
        }
      .filter (entry) ->
        entry.lastModified? && Dates.parse(entry.lastModified) < Date.now() - Util.getMs({ days: 30 })
      .sortBy (entry) -> -entry.cardCount
      .first 5
      .value()

    @$el.html(template({
      ageCategories: @_ageCategories()
      lists
    }))

    _.keys(CATEGORIES).forEach (category) =>
      @_updateCategory(category)

    @

  archiveCategory: (e) ->
    Util.stop(e)
    category = @$(e.currentTarget).attr('data-category')

    checked = {}

    @$('.js-category-cards')
    .filter(filterByAttr('data-category', category))
    .find('.js-toggle-checkbox')
    .each (index, el) =>
      $checkbox = @$(el)
      idCard = $checkbox.attr('data-card')
      checked[idCard] = $checkbox.is('[data-checked]')
      return

    cards = @_ageCategories()[category].filter (card) ->
      checked[card.id]

    if cards?
      Confirm.toggle 'archive cards',
        elem: e.target
        model: @model
        fxConfirm: (e) =>
          track("Board Clean-Up", "Archive By Age", category, cards.length)

          @stopListeningForCards()
          @progress =
            count: 0
            total: cards.length
          @render()

          @aborted = false
          Promise.map(cards, (card) =>
            if @aborted
              return

            started = Date.now()

            Promise.fromNode (callback) ->
              card.close(callback)
            .then ->
              elapsed = Date.now() - started
              remaining = MINIMUM_TIME - elapsed
              if remaining > 0
                Promise.delay(remaining)
            .then =>
              @progress.count++
              @render()
          , { concurrency: CONCURRENCY })
          .catch(=>)
          .then =>
            @progress = null
            @listenForCards()
            @render()
          .done()


  archiveList: (e) ->
    Util.stop(e)
    idList = @$(e.currentTarget).attr('data-list')

    list = @model.listList.get(idList)

    track("Board Clean-Up", "Archive List", undefined, list.openCards().models.length)

    list.close()

  abort: ->
    @aborted = true
    if @progress
      track("Board Clean-Up", "Abort Archive By Age", undefined, @progress.total - @progress.count)



// WEBPACK FOOTER //
// ./app/scripts/views/board/board-clean-up-view.coffee